<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.resources'">
    <div class="row pb-2 g-2">
      <div class="col-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-1">
              {{t('General info')}}
              <help-button *transloco="let h" [key]="h('help.ime.manufacturing.resources')"></help-button>
              <app-favourites-toggle [model]="resource" [route]="'manufacturing/resource/edit/'"></app-favourites-toggle>
            </h5>
            <div class="form-group row">
              <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="code" name="code" [(ngModel)]="resource.Code">
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="name" name="name" [(ngModel)]="resource.Name">
              </div>
            </div>
            <div class="form-group row">
              <label for="bottleneck" class="col-sm-4 col-form-label">{{t('Bottleneck')}}</label>
              <div class="col-sm-8">
                <ng-select class="select-sm form-control" [items]="classificatorValueService.bottlenecks$ | async" labelForId="bottleneck" id="bottleneck" name="bottleneck" [(ngModel)]="resource.BottleneckClv"
                           bindLabel="DisplayName" [virtualScroll]="true"
                           bindValue="Id">
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="type" class="col-sm-4 col-form-label">{{t('Type')}}</label>
              <div class="col-sm-8">
                <mes-web-classificator-value-select [entityId]="resource.ResourceTypeClv" (entityIdChange)="resource.ResourceTypeClv = $event" id="type" [items$]="classificatorValueService.resourceTypes$" [allowAdd]="false"
                                                    [name]="'resourceTypes'"></mes-web-classificator-value-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="kind" class="col-sm-4 col-form-label">{{t('Kind')}}</label>
              <div class="col-sm-8">
                <ng-select class="select-sm form-control" [items]="classificatorValueService.resourceKinds$ | async" labelForId="kind" id="kind" name="kind" [(ngModel)]="resource.KindClv"
                           bindLabel="DisplayName" [virtualScroll]="true"
                           bindValue="Id">
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="status" class="col-sm-4 col-form-label">{{t('Status')}}</label>
              <div class="col-sm-8">
                <ng-select class="select-sm form-control" [items]="classificatorValueService.getAll$ | async | where: 'ClassificatorId': resource.StatusCl" labelForId="status" id="status" name="status" [(ngModel)]="resource.StatusClv"
                           bindLabel="DisplayName" [virtualScroll]="true"
                           bindValue="Id">
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="AssignedResourceQuantityFlagClv" class="col-sm-4 col-form-label">{{t('Assigned Resource Quantity Flag')}}</label>
              <div class="col-sm-8">
                <mes-web-classificator-value-select [entityId]="resource.AssignedResourceQuantityFlagClv" (entityIdChange)="resource.AssignedResourceQuantityFlagClv = $event" id="AssignedResourceQuantityFlagClv"
                                                    [items$]="classificatorValueService.assignedResourceQuantityFlagClv$" [allowAdd]="false" [name]="'AssignedResourceQuantityFlagClv'"></mes-web-classificator-value-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="ResourceQuantityConstraintsClv" class="col-sm-4 col-form-label">{{t('Resource Quantity Constraints')}}</label>
              <div class="col-sm-8">
                <mes-web-classificator-value-select [entityId]="resource.ResourceQuantityConstraintsClv" (entityIdChange)="resource.ResourceQuantityConstraintsClv = $event" id="ResourceQuantityConstraintsClv"
                                                    [items$]="classificatorValueService.resourceQuantityConstraintsClv$" [allowAdd]="false" [name]="'ResourceQuantityConstraintsClv'"></mes-web-classificator-value-select>
              </div>
            </div>
            <div class="form-group row">
              <label for="ResourceLTimeBuffer" class="col-sm-4 col-form-label">{{t('Resource L Time Buffer')}}</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="ResourceLTimeBuffer" name="ResourceLTimeBuffer" [(ngModel)]="resource.ResourceLTimeBuffer">
              </div>
            </div>
            <div class="form-group row">
              <label for="ResourceRTimeBuffer" class="col-sm-4 col-form-label">{{t('Resource R Time Buffer')}}</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="ResourceRTimeBuffer" name="ResourceRTimeBuffer" [(ngModel)]="resource.ResourceRTimeBuffer">
              </div>
            </div>
            <div class="form-group row">
              <label for="Production" class="col-sm-4 col-form-label">{{t('Production')}}</label>
              <div class="col-sm-8">
                <mes-web-expression-formula cssClass="form-control mx-w-100" id="Production" name="Production" [expression]="resource.Production"></mes-web-expression-formula>
              </div>
            </div>
            <div class="form-group row">
              <label for="Setup" class="col-sm-4 col-form-label">{{t('Setup')}}</label>
              <div class="col-sm-8">
                <mes-web-expression-formula cssClass="form-control mx-w-100" id="Setup" name="Setup" [expression]="resource.Setup"></mes-web-expression-formula>
              </div>
            </div>
            <div class="form-group row">
              <label for="Teardown" class="col-sm-4 col-form-label">{{t('Teardown')}}</label>
              <div class="col-sm-8">
                <mes-web-expression-formula cssClass="form-control mx-w-100" id="Teardown" name="Teardown" [expression]="resource.Teardown"></mes-web-expression-formula>
              </div>
            </div>
            <div class="form-group row">
              <label for="Yield" class="col-sm-4 col-form-label">{{t('Yield')}}</label>
              <div class="col-sm-8">
                <mes-web-expression-formula cssClass="form-control mx-w-100" id="Yield" name="Yield" [expression]="resource.Yield"></mes-web-expression-formula>
              </div>
            </div>
            <div class="form-group row">
              <label for="ProductionFactor" class="col-sm-4 col-form-label">{{t('Production Factor')}}</label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="ProductionFactor" name="ProductionFactor" [(ngModel)]="resource.ProductionFactor">
              </div>
            </div>
            <div class="form-group row">
              <label for="comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
              <div class="col-sm-8">
                <textarea class="form-control" id="comment" name="comment" autosize [(ngModel)]="resource.Comment"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100"></div>
      </div>
      <div class="col-6">
        <div class="card mb-2" *ngIf="resource.KindClv === global.Classificators.ResourceKind.Person || resource.KindClv === global.Classificators.ResourceKind.Area">
          <div class="card-body">
            <h5 class="card-title">
              {{t('User')}}
            </h5>
            <div class="form-group row">
              <label for="user" class="col-sm-2 col-form-label">{{t('User')}}</label>
              <div class="col-sm-10">
                <mes-user-select id="user" name="user" [entityId]="resource.UserId" [items$]="usersQuery.getAll$" [allowAdd]="false" [placeholder]="t('Leave this field empty for adding a new user or select from existing')"
                                 (entityIdChange)="resource.UserId = $event; ensureUser(); setChanged()"></mes-user-select>
              </div>
            </div>
            <mes-user-edit *ngIf="resource.User" [user]="resource.User" (userChanged)="setChanged()"></mes-user-edit>
          </div>
        </div>
        <ng-container [ngTemplateOutlet]="resourceConnectionList" [ngTemplateOutletContext]="{title: toConnectionTitle$, connections: resource.ToResourceConnections, type: 'To'}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="resourceConnectionList" [ngTemplateOutletContext]="{title: fromConnectionTitle$, connections: resource.FromResourceConnections, type: 'From'}">
        </ng-container>
        <ng-template #resourceConnectionList let-title$="title" let-connections="connections" let-type="type">
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex">
                <h5 class="d-inline my-auto">{{title$ | async}}</h5>
                <button class="btn btn-sm btn-outline-primary ms-auto" (click)="addConnection(type)">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                  {{t('Add')}}
                </button>
              </div>
              <p-table *ngIf="connections?.length"
                       styleClass="p-datatable-xs p-datatable-borderless white-rows p-inner-table-auto mt-1"
                       [value]="connections"
                       [rowHover]="true"
                       [autoLayout]="false"
                       [rowTrackBy]="trackByFunction"
                       [paginator]="connections.length > 10"
                       [showCurrentPageReport]="true"
                       [rowsPerPageOptions]="[10,25,50,100,200]"
                       [rows]="type === 'To' ? toConnectionRowsPerPage : fromConnectionRowsPerPage" (rowsChange)="type === 'To' ? toConnectionRowsPerPage : fromConnectionRowsPerPage = $event"
                       [first]="type === 'To' ? toConnectionFirstRow : fromConnectionFirstRow" (firstChange)="type === 'To' ? toConnectionFirstRow : fromConnectionFirstRow = $event"
                       [customSort]="true"
                       (sortFunction)="customSort($event)"
                       currentPageReportTemplate="{first} to {last} of {totalRecords}"
                       dataKey="Id">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="min-wx-192" pSortableColumn="{{type === 'To' ? 'FromResourceId' : 'ToResourceId'}}">
                      {{getResourceTypeLabel(connections[0]) | async}}
                      <p-sortIcon field="{{type === 'To' ? 'FromResourceId' : 'ToResourceId'}}"></p-sortIcon>
                    </th>
                    <th class="wx-96" pSortableColumn="TypeClv">
                      {{t('Type')}}
                      <p-sortIcon field="TypeClv"></p-sortIcon>
                    </th>
                    <th style="width: 170px">
                      {{t('From/To')}}
                    </th>
                    <th class="wx-56" pSortableColumn="Quantity">
                      {{t('Quantity')}}
                      <p-sortIcon field="Quantity"></p-sortIcon>
                    </th>
                    <th class="wx-48" pSortableColumn="IsDefault">
                      {{t('Main')}}
                      <p-sortIcon field="IsDefault"></p-sortIcon>
                    </th>
                    <th style="width: 76px"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr class="p-selectable-row">
                    <td pEditableColumn mesStopClickPropagation class="text-wrap text-break parent">
                      <ng-container *ngIf="type === 'To'; else fromConnections">
                        <p-cellEditor *ngIf="!row.$isNew; else selectResourceTmpl">
                          <ng-template pTemplate="output">
                            <ng-container *ngIf="!row.FromResourceId; else fromResourceTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.resources.Resource'}"></ng-container>
                            <ng-template #fromResourceTmpl>
                              <span [ngClass]="{'fw-bold': row.isActiveDefault()}">{{(resources | find: ['Id'] : row.FromResourceId) | displayName}}</span>
                            </ng-template>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <ng-template [ngTemplateOutlet]="selectResourceTmpl"></ng-template>
                          </ng-template>
                        </p-cellEditor>
                      </ng-container>
                      <ng-template #fromConnections>
                        <p-cellEditor *ngIf="!row.$isNew; else selectResourceTmpl">
                          <ng-template pTemplate="output">
                            <ng-container *ngIf="!row.ToResourceId; else toResourceTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.resources.Resource'}"></ng-container>
                            <ng-template #toResourceTmpl>
                              <span [ngClass]="{'fw-bold': row.isActiveDefault()}">{{(resources | find: ['Id'] : row.ToResourceId) | displayName}}</span>
                            </ng-template>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <ng-template [ngTemplateOutlet]="selectResourceTmpl"></ng-template>
                          </ng-template>
                        </p-cellEditor>
                      </ng-template>
                      <ng-template #selectResourceTmpl>
                        <mes-web-resource-select id="ResourceId-{{row.Id}}" [items$]="resourceService.getAll$" [entityId]="type === 'To' ? row.FromResourceId : row.ToResourceId" (entityIdChange)="type === 'To' ? row.FromResourceId = $event : row.ToResourceId = $event; row.$isNew = false" [multiple]="false" [initOpened]="true"
                                                 [name]="'ResourceId-' + row.Id"></mes-web-resource-select>
                      </ng-template>
                    </td>
                    <td pEditableColumn class="parent">
                      <p-cellEditor>
                        <ng-template pTemplate="output">
                          <ng-container *ngIf="!row.TypeClv" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.resources.Type'}"></ng-container>
                          {{(classificatorValueService.resourceConnectionTypes$ | async | find : ['Id'] : row.TypeClv) | displayName}}
                        </ng-template>
                        <ng-template pTemplate="input">
                          <mes-web-classificator-value-select id="TypeClv-{{row.Id}}" name="TypeClv-{{row.Id}}" [items$]="classificatorValueService.resourceConnectionTypes$" [entityId]="row.TypeClv" (entityIdChange)="row.TypeClv = $event" [allowAdd]="false" [allowEdit]="false" [initOpened]="true"></mes-web-classificator-value-select>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td pEditableColumn mesStopClickPropagation class="parent">
                      <p-cellEditor>
                        <ng-template pTemplate="output">
                          <ng-container *ngIf="!row.FromDate && !row.ToDate; else fromToTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.resources.From/To'}"></ng-container>
                          <ng-template #fromToTmpl>
                            <div>
                              {{row.FromDate | date: 'dd.MM.yyyy'}} - {{row.ToDate | date: 'dd.MM.yyyy'}}
                            </div>
                          </ng-template>
                        </ng-template>
                        <ng-template pTemplate="input">
                          <mes-date-range-picker [fromDate]="row.FromDate" [toDate]="row.ToDate" [format]="'dd.MM.yyyy'" [hasButton]="false" [small]="false" [initOpened]="true"
                                                 (dateSelect)="setDateRange($event, row)"></mes-date-range-picker>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td pEditableColumn class="parent">
                      <p-cellEditor>
                        <ng-template pTemplate="output">
                          <ng-container *ngIf="!row.Quantity" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.resources.Quantity'}"></ng-container>
                          <div class="d-flex w-100">
                            <span class="ms-auto">{{row.Quantity}}</span>
                          </div>
                        </ng-template>
                        <ng-template pTemplate="input">
                          <input mesStopArrowKeyPropagation type="number" class="form-control" id="Quantity-{{row.Id}}" name="Quantity-{{row.Id}}" [(ngModel)]="row.Quantity">
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <div class="d-flex">
                        <input type="checkbox" class="form-check-input position-static mx-auto my-auto" [(ngModel)]="row.IsDefault" id="IsMain-{{row.Id}}" name="IsMain-{{row.Id}}">
                      </div>
                    </td>
                    <td style="white-space: nowrap">
                      <button class="btn btn-sm btn-outline-primary me-1" (click)="openResource(type === 'To' ? row.FromResourceId : row.ToResourceId)">
                        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="removeConnection(row, type)">
                        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #editIcon let-columnName="columnName">
                  <span class="show-on-parent-hover text-gray-400 text-nowrap">
                    {{columnName | transloco}}
                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
                  </span>
                </ng-template>
              </p-table>
            </div>
          </div>
        </ng-template>
        <mes-web-cost-price-components-edit-card [cssClass]="'mt-2'" [container]="resource" (changed)="setChanged()"></mes-web-cost-price-components-edit-card>
      </div>
    </div>
    <div class="row pb-2">
      <div class="col">
        <div class="card">
          <div class="card-body" *ngIf="(stateService.settings$ | async) as settings">
            <div class="d-flex pb-1">
              <h5 class="d-inline-block">{{t('Specs')}}</h5>
              <help-button *transloco="let h" [key]="h('help.ime.common.specs')"></help-button>
              <div class="ms-auto">
                <button class="btn btn-sm btn-outline-primary me-1" [ngClass]="{'active': showPropertyLocalizations}" *ngIf="settings.Property.Localization"
                        (click)="showPropertyLocalizations = !showPropertyLocalizations">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
                  {{t('Localization')}}
                </button>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent?.addNewSpecLine()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                  {{t('Add')}}
                </button>
              </div>
            </div>
            <ime-spec-lines-edit [context]="resource"
                                 [showLocalization]="showPropertyLocalizations"
                                 [showLocalizationButton]="settings.Property.Localization"
                                 [wasValidated$]="wasValidated$"
                                 (changed)="setChanged()"></ime-spec-lines-edit>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>
